import pick from 'lodash/pick';
import {
  SET_CONTACT_INFO,
  UPDATE_CONTACT_DETAILS_DONE,
  FETCH_COUNTRY_LIST
} from '../actions';
const initState = {
  company_name: '',
  address: '',
  address2: '',
  city: '',
  country: '',
  zip: '',
  state: '',
  countryListMap: null,

  email: '',
  phone: '',
  name: '',
}

function getMyCountry(countryListMap, countryCode){
  const myCountry = countryListMap && Object.entries(countryListMap).find(([name, code]) => code === countryCode );
  if(myCountry){
    return myCountry[0]
  }
  return countryCode;
}

function contactDetails (state = initState, action) {
  switch(action.type) {
    case SET_CONTACT_INFO:
    case UPDATE_CONTACT_DETAILS_DONE:{
      const newPayload = {...action.payload}
      newPayload.country = getMyCountry(state.countryListMap,newPayload.country);
      return { ...state, ...pick(newPayload, Object.keys(initState)) };
    }
    case `${FETCH_COUNTRY_LIST}_SUCCESS`:{
        const country = getMyCountry(action.payload.countryList,state.country);
        return {...state, countryListMap: action.payload.countryList, country};
    } 
    default: 
      return state;
  }
}
export default contactDetails;